import React from 'react';

/**
 * Horizontal stacked funnel. Each row is a stage; width proportional to step-over-top.
 * Stages:
 *   1. Signed up
 *   2. Joined a family
 *   3. Logged first expense
 *   4. Active in week 1
 */
const ActivationFunnel = ({ funnel }) => {
  const signups = funnel?.signups || 0;
  const joinedFamily = funnel?.joinedFamily || 0;
  const firstExpense = funnel?.firstExpense || 0;
  const week1Active = funnel?.week1Active || 0;

  const stages = [
    { label: 'Signed up', value: signups, color: '#1B6B4A' },
    { label: 'Joined a family', value: joinedFamily, color: '#3BA676' },
    { label: 'Logged first expense', value: firstExpense, color: '#F5C842' },
    { label: 'Active in week 1', value: week1Active, color: '#F2886D' },
  ];

  const max = Math.max(1, signups);

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">Activation funnel</h3>
        <span className="text-xs text-ink-400">Last 30 days of signups</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        Signup → join family → first expense → week-1 active. Look for the biggest step-over-step drop.
      </p>
      <div className="space-y-3">
        {stages.map((stage, idx) => {
          const pct = max > 0 ? (stage.value / max) * 100 : 0;
          const prev = idx === 0 ? stage.value : stages[idx - 1].value;
          const conversion = prev > 0 ? (stage.value / prev) * 100 : 0;
          return (
            <div key={stage.label}>
              <div className="flex items-center justify-between text-sm mb-1.5">
                <span className="font-semibold text-ink-800">{stage.label}</span>
                <span className="text-ink-500 tabular-nums">
                  <span className="font-semibold text-ink-900">{stage.value.toLocaleString()}</span>
                  {idx > 0 && (
                    <span className="text-ink-400 ml-2">· {conversion.toFixed(0)}%</span>
                  )}
                </span>
              </div>
              <div className="h-8 bg-surface-100 rounded-lg overflow-hidden relative">
                <div
                  className="h-full rounded-lg transition-all duration-500 ease-out flex items-center justify-end pr-3"
                  style={{ width: `${Math.max(2, pct)}%`, backgroundColor: stage.color }}
                >
                  <span className="text-xs font-semibold text-white">
                    {pct.toFixed(0)}%
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivationFunnel;
